// extracted by mini-css-extract-plugin
export default {"wrapper":"ShareSocials_wrapper__UdoXD","icon":"ShareSocials_icon__wvUC8","share-item":"ShareSocials_share-item__4JFgN","socials":"ShareSocials_socials__Ad989"};